module.exports = __webpack_public_path__ + "static/reduce-plastic-717d5c8451b7ebc5292a9a1f300bb1e6.jpg";